import { render, staticRenderFns } from "./PortalFooter.vue?vue&type=template&id=2dd96caf&scoped=true&"
import script from "./PortalFooter.vue?vue&type=script&lang=js&"
export * from "./PortalFooter.vue?vue&type=script&lang=js&"
import style0 from "./PortalFooter.vue?vue&type=style&index=0&id=2dd96caf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd96caf",
  null
  
)

export default component.exports